<template>
<transition name="slide-fade">
    <div class="dialog-view" v-if="visible">        
        <div class="buy-modal u-window">           
            <div class="dialog-content">
                <div class="u-btn close" @click="closeModal"></div>
                <div class="dialog-wrapper">
                    <h5 class="title"></h5>
                    <div class="buy-view">
                        <div class="exp-info">
                            <p>当前经验：<b>{{ exp_result() }}</b></p>
                            <p>本周可购经验：<b>{{ $global.EXP[$store.state.account.week - 1] - exp_result() }}</b></p>
                        </div>

                        <div class="block">
                            <el-slider
                            v-model="value"
                            :min="0"
                            :max="$global.EXP[$store.state.account.week - 1] - exp_result()"
                            >
                            </el-slider>

                            <div class="marks">
                                <div class="min">0</div>
                                <div class="max">{{ $global.EXP[$store.state.account.week - 1]- exp_result() }}</div>
                            </div>

                            <div class="manual">
                                <span>输入数量</span>
                                <el-input-number v-model="value" :min="0" :max="$global.EXP[$store.state.account.week - 1] - exp_result()"></el-input-number>
                            </div>
                           
                        </div>

                    </div>

                    <div class="u-ctrl">
                        <div class="u-btn cancel" @click="closeModal"></div>
                        <div class="u-btn ok" @click="buy"><div class="sum">{{ value }}</div></div>
                    </div>
                </div>
            </div>            
        </div> 
        <div class="u-mask"></div>
    </div>
</transition>     
</template>


<style scoped>
.buy-modal{
    position: relative;
    width: 578px;
    height: 532px;
    font-size: 24px;
    color: #6f3615;
    background-image: url(~@/assets/images/bg-exp_buy.png);
}

.title{
    width: 195px;
    height: 27px;
    margin: 15px auto 60px;
    background-image: url(~@/assets/images/title-buy.png);    
}

.buy-view{
    padding: 10px 45px 0;
    line-height: 1.8;
    font-size: 24px;
    color: #713725;
    /* text-align: center; */
}

.exp-info{
    display: flex;
    justify-content: space-between;
    margin-bottom: 70px;
}

.exp-info b{
    font-weight: 400;
    color: #fe5a1e;
}

.marks{
    display: flex;
    justify-content: space-between;
    margin-top: -10px;
}

.buy-view .icon{
    display: inline-block;
    width: 31px;
    height: 30px;
    margin: 0 5px;
    background-image: url(~@/assets/images/icon-m3b.png);
    vertical-align: sub;
}

.u-ctrl{
    position: absolute;
    left: 50%;
    bottom: 58px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    padding: 0 42px;
    box-sizing: border-box;
    transform: translateX(-50%);
}

.u-ctrl .u-btn.cancel{
    width: 225px;
    height: 60px;
    background-image: url(~@/assets/images/btn-cancel.png);    
}

.u-ctrl .u-btn.ok{
    position: relative;
    width: 225px;
    height: 60px;
    background-image: url(~@/assets/images/btn-buy.png);    
}

.u-btn .sum{
    position: absolute;
    left: 69px;
    top: 14px;
    width: 3em;
    font-size: 28px;
    color: #fff2bb;
    text-align: center;
}

.manual{
    display: flex;
}

.manual span{
    padding-right: 20px;
}
</style>

<style>
.el-slider__runway{
    height: 10px;
    border: 1px solid #795d33;
    border-radius: 5px;
}

.el-slider__bar{
    height: 10px;
    background: linear-gradient(to bottom, #f5a24d, #e96a33);
}

.el-slider__button{
    width: 14px;
    height: 14px;
    border: 2px solid #795d33;
}

.el-tooltip__popper.is-dark{
    font-size: 24px;
    color: #96261a;
    background-color: transparent;
}

.el-tooltip__popper .popper__arrow{
    width: 12px;
    height: 21px;
    bottom: -10px;
    background-image: url(~@/assets/images/icon-arrow.png); 
    border: none;
}

.el-tooltip__popper .popper__arrow::after{
    display: none;
}

.el-input{
    /* width: 345px; */
}

.el-input__inner{
    font-size: 24px;
}
</style>

<script>
export default {
    data () {
        return {
            visible : false,
            gid : '1',
            giftName : '经验值',
            cost : 1,
            num : 1,
            score : 0,
            value : 0,
        }
    },
    watch: {
        closed (newVal) {
            if (newVal) {
                this.visible = false
                this.destroyElement()
            }
        }
    },
    created (){
        //this.$be_busy();
        //console.log(this.$store.state.account.canBuy)
    },
    methods : {
        destroyElement () {
            //this.$be_free();
            this.$destroy()
            this.$el.parentNode.removeChild(this.$el)
        },        
        closeModal(){
            this.destroyElement()
        },
        handleChange(value) {
            //console.log(value);
        },
        exp_result (){
            let vm = this;
            return Math.min( (vm.$store.state.account.buy +  vm.$store.state.account.killScore) ,  vm.$global.EXP[vm.$store.state.account.week - 1]);
        },                  
        buy (){

            if(!this.$store.state.userinfo.uid){
                return this.$mslogin.open();
            }

            if(!this.$store.state.userinfo.areaId){
                this.$toast('请绑定大区');
                this.closeModal();

                return this.$bind_modal();
            }

            if(!this.value)return this.$toast('请选择购买数量');

            this.$axios.post(globalThis.ajax_url_map.buy,{
                giftId : this.gid,
                num : this.value,
            })
            .then(
                res => {
                    this.destroyElement ();                
                    this.$success_Modal({text : '成功获得'+ this.value +'经验'});
                    
                    this.$store.commit("$_setFinishRate", this.value + (this.$store.state.account.buy +  this.$store.state.account.killScore));
                    this.$store.commit("$_setExp", this.value);
                    
                    //TODO refresh

                    //this.$update_userType(10)
                },
                rej => {
                    this.destroyElement ();
                    let type = rej.code == 416 ? 2 : 1;
                    this.$error_Modal({text : rej.message , type : type});
                },
            )

        },        
    },    
}
</script>


// WEBPACK FOOTER //
// src/components/BuyModal/buyModal.vue